module.exports = __webpack_public_path__ + "static/media/ci-1.f7ff2010.jpg";